export default {
  title: '메미데브',
  description: '개발에 대한 모든 것을 다룹니다',
  logo: '/logo.png',
  domain: 'memi.dev',
  url: 'https://memi.dev',
  owner: '정준호',
  email: 'fkkmemi@gmail.com',
  createdAt: new Date('2020-08-27')
}
